export const FIRST_STEP = "v2/establishment/signup-account";
export const SECOND_STEP = "v2/establishment/signup-ngo";
export const THIRD_STEP = "v2/establishment/signup-members";
export const VERIFY = (id) => `v2/establishment/email/verify/${id}`;
export const LOGO = (id) => `v2/guest/ngo-logo/${id}`;
export const DECISIONS_BY_ID = (id) => `/v2/guest/regulations/${id}?model=decision`;
export const DECISIONS = `/v2/guest/regulations?model=decision`;
